import React from 'react';
import { Box, Dialog, Typography } from '@mui/material';
import { PrimaryButton, SecondaryButton } from './Buttons';
import { tokens } from './tokens';

/** Bottom-sheet confirmation used for "Remove activity?" and "Start over?". */
export const ConfirmSheet: React.FC<{
  open: boolean;
  icon: React.ReactNode;
  title: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  children: React.ReactNode;
}> = ({ open, icon, title, confirmLabel, cancelLabel, onConfirm, onCancel, children }) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="smart-goal-sheet-title"
    sx={{ '& .MuiDialog-container': { alignItems: 'flex-end' } }}
    slotProps={{
      paper: {
        sx: {
          width: '100%',
          maxWidth: 340,
          m: '0 16px 24px',
          borderRadius: '16px',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 2.5,
          boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
        },
      },
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, textAlign: 'center' }}>
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          background: tokens.borderSubtle,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: tokens.icon,
        }}
      >
        {icon}
      </Box>
      <Typography
        id="smart-goal-sheet-title"
        component="h2"
        sx={{ fontSize: '16px', fontWeight: 600, color: tokens.title }}
      >
        {title}
      </Typography>
      <Typography sx={{ fontSize: '15px', color: tokens.textPrimary, lineHeight: 1.6 }}>{children}</Typography>
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <PrimaryButton onClick={onConfirm} sx={{ py: '13px' }}>
        {confirmLabel}
      </PrimaryButton>
      <SecondaryButton onClick={onCancel} sx={{ py: '13px', borderColor: tokens.border, color: tokens.textPrimary }}>
        {cancelLabel}
      </SecondaryButton>
    </Box>
  </Dialog>
);
